import React__default, { useContext } from 'react';

var Application;

(function (Application) {
  Application[Application["BUSINESS"] = 0] = "BUSINESS";
  Application[Application["CONSUMER"] = 1] = "CONSUMER";
  Application[Application["OPERATIONS"] = 2] = "OPERATIONS";
})(Application || (Application = {}));

var ApplicationContext = React__default.createContext(undefined);
var ApplicationContextProvider = ApplicationContext.Provider;
var ApplicationContextConsumer = ApplicationContext.Consumer;

var useApplicationContext = function useApplicationContext() {
  var applicationContext = useContext(ApplicationContext);

  if (!applicationContext) {
    throw new Error('Invoked application context without intital application defintion');
  }

  return applicationContext;
};

export { Application, ApplicationContext, ApplicationContextConsumer, ApplicationContextProvider, useApplicationContext };
//# sourceMappingURL=index.js.map
